import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

/* Firebase web config is public by design. Values can still be overridden per
   environment without a code change. */
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyALBJb95Iii9TkqXyXUtkdqOvy0Owpyfk8",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "fire-detect-37214.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://fire-detect-37214-default-rtdb.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "fire-detect-37214",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "fire-detect-37214.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "440410504810",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:440410504810:web:1a464feaa3efd7dd035413",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-HKYJP0W1CR",
};

const app = initializeApp(firebaseConfig);

/* Analytics is optional. It throws in browsers without IndexedDB and in
   private windows — which used to take the whole page down with it. */
isSupported()
  .then((supported) => {
    if (supported) getAnalytics(app);
  })
  .catch(() => {});

const database = getDatabase(app);
const storage = getStorage(app);

export { app, database, storage };
